import { t } from 'i18next';

import { Paragraph } from '@app/shared/ui/atoms/Common';

interface PlayerTitleProps {
  title?: string;
  description?: string;
}

export const PlayerTitle = ({ title, description }: PlayerTitleProps) => {
  return (
    <div>
      {title && (
        <h3 className="text-lg font-semibold mb-1 text-foreground/90">
          {t(`media.title.${title}`)}
        </h3>
      )}
      {description && (
        <Paragraph className="text-foreground/70">
          {t(`media.description.${description}`)}
        </Paragraph>
      )}
    </div>
  );
};
